export const SET_INTERNAL_PAGE_PARAM = 'uf/internal/SET_INTERNAL_PAGE_PARAM';

export const SET_INTERNAL_PAGE_KEY = 'uf/internal/SET_INTERNAL_PAGE_KEY';

export const ROUTE_INTERNAL = 'INTERNAL';
